export default __webpack_public_path__ + "static/media/Undulating Band of Yig.1100592f.jpg";